import { PURCHASE_INTENT_LIMITS } from '@/constants/purchaseIntent';
import {
  getCartItemQuantity,
  getCartItemUnitYuan,
} from '@/utils/ipeRechargeCart';

/** 购物车行里已映射到提交体的字段；其余进入 extra，避免以后加车字段就丢。 */
const KNOWN_CART_KEYS = new Set([
  'id',
  'kind',
  'packGroup',
  'scope',
  'title',
  'summary',
  'unitPriceYuan',
  'priceYuan',
  'quantity',
  'durationMonths',
  'tier',
  'packId',
  'productTypeLabel',
  'priceLabel',
  'addedAt',
]);

export const EMPTY_PURCHASE_INTENT_CONTACT = {
  companyName: '',
  contactName: '',
  contactPhone: '',
};

export const PURCHASE_INTENT_SUBMITTED_TOAST = '意向已提交，商务将与您联系';

function trimText(value) {
  return String(value ?? '').trim();
}

function hanCount(value) {
  return (String(value || '').match(/[\u4e00-\u9fff]/g) || []).length;
}

export function normalizePurchaseIntentCompanyName(value) {
  return trimText(value)
    .replaceAll('(', '（')
    .replaceAll(')', '）')
    .replace(/\s+/g, '');
}

function pickExtra(item) {
  const extra = {};
  Object.entries(item || {}).forEach(([key, value]) => {
    if (!KNOWN_CART_KEYS.has(key) && value !== undefined) {
      extra[key] = value;
    }
  });
  return extra;
}

export function cartItemToPurchaseIntentLine(item) {
  const extra = pickExtra(item);
  return {
    kind: trimText(item?.kind),
    packGroup: trimText(item?.packGroup) || undefined,
    scope: trimText(item?.scope) || 'personal',
    title: trimText(item?.title) || '商品',
    summary: trimText(item?.summary),
    unitPriceYuan: getCartItemUnitYuan(item),
    quantity: getCartItemQuantity(item),
    durationMonths: Number(item?.durationMonths) > 0 ? Number(item.durationMonths) : undefined,
    tier: trimText(item?.tier) || undefined,
    packId: item?.packId == null || item?.packId === '' ? undefined : String(item.packId),
    productTypeLabel: trimText(item?.productTypeLabel) || undefined,
    extra: Object.keys(extra).length ? extra : undefined,
  };
}

export function buildPurchaseIntentItems(items) {
  return (items || []).map(cartItemToPurchaseIntentLine);
}

export function validatePurchaseIntentContact(form) {
  const companyName = normalizePurchaseIntentCompanyName(form?.companyName);
  const contactName = trimText(form?.contactName);
  const contactPhone = trimText(form?.contactPhone);
  const errors = {};

  if (companyName.length < PURCHASE_INTENT_LIMITS.companyNameMin
    || companyName.length > PURCHASE_INTENT_LIMITS.companyNameMax) {
    errors.companyName = `公司名称须为 ${PURCHASE_INTENT_LIMITS.companyNameMin}～${PURCHASE_INTENT_LIMITS.companyNameMax} 个字`;
  } else if (
    !PURCHASE_INTENT_LIMITS.companyNamePattern.test(companyName)
    || hanCount(companyName) < PURCHASE_INTENT_LIMITS.companyNameMin
  ) {
    errors.companyName = PURCHASE_INTENT_LIMITS.companyNameCharsetMessage;
  }
  if (contactName.length < PURCHASE_INTENT_LIMITS.contactNameMin
    || contactName.length > PURCHASE_INTENT_LIMITS.contactNameMax) {
    errors.contactName = `联系人姓名须为 ${PURCHASE_INTENT_LIMITS.contactNameMin}～${PURCHASE_INTENT_LIMITS.contactNameMax} 个字`;
  }
  if (!PURCHASE_INTENT_LIMITS.contactPhonePattern.test(contactPhone)) {
    errors.contactPhone = '联系人电话格式不正确';
  }

  return {
    ok: Object.keys(errors).length === 0,
    errors,
    values: { companyName, contactName, contactPhone },
  };
}

export function validatePurchaseIntentItems(items) {
  const list = Array.isArray(items) ? items : [];
  if (!list.length) {
    return { ok: false, message: '请至少选择一件商品' };
  }
  if (list.length > PURCHASE_INTENT_LIMITS.itemsMax) {
    return { ok: false, message: `单次提交商品不能超过 ${PURCHASE_INTENT_LIMITS.itemsMax} 项` };
  }
  if (list.some((item) => !trimText(item?.title) && !trimText(item?.kind))) {
    return { ok: false, message: '商品信息不完整，请重新选择后再提交' };
  }
  return { ok: true, message: '' };
}

export function buildPurchaseIntentSubmitPayload(form, items) {
  const contact = validatePurchaseIntentContact(form);
  const goods = validatePurchaseIntentItems(items);
  if (!contact.ok) {
    return { ok: false, errors: contact.errors, message: Object.values(contact.errors)[0] };
  }
  if (!goods.ok) {
    return { ok: false, errors: {}, message: goods.message };
  }
  return {
    ok: true,
    errors: {},
    payload: {
      ...contact.values,
      items: buildPurchaseIntentItems(items),
    },
  };
}

